export class SearchError extends Error {}
